import script from "./HistoricalLabourForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricalLabourForm.vue?vue&type=script&setup=true&lang=js"

import "./HistoricalLabourForm.vue?vue&type=style&index=0&id=7d421841&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d421841"]])

export default __exports__